import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Background from './asserts/pic.png';
import author from './asserts/author.png'
import qrCode from './asserts/donate/qrCode.png'
import { color } from "framer-motion";

const buttonBaseStyle = {
  padding: "14px 24px",
  borderRadius: "10px",
  fontWeight: "600",
  fontSize: "16px",
  color: "#fff",
  textDecoration: "none",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  transition: "all 0.25s ease",
  border: "none",
  boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
};


const LandingPage = () => {
  const [aboutOpen, setAboutOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [hintsOpen, setHintsOpen] = useState(false);
  const [dontShowAgain, setDontShowAgain] = useState(false);
  const [mode, setMode] = useState("skydive");
  // skydive | tunnel
  const theme = mode === "skydive"
    ? {
      primary: "#1D4ED8",
      primaryHover: "#1E40AF",
      secondary: "#059669",
      secondaryHover: "#047857",
      neutral: "#4B5563",
      neutralHover: "#374151"
    }
    : {
      primary: "#7C3AED",
      primaryHover: "#6D28D9",
      secondary: "#0EA5E9",
      secondaryHover: "#0284C7",
      neutral: "#374151",
      neutralHover: "#1F2937"
    };
  useEffect(() => {
    const saved = localStorage.getItem("mode");
    if (saved) setMode(saved);
  }, []);

  useEffect(() => {
    localStorage.setItem("mode", mode);
  }, [mode]);

  useEffect(() => {

    const fetchUser = async () => {
      try {
        const res = await fetch("/api/user/me", {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        });

        if (!res.ok) return;

        const user = await res.json();

        if (user.showHints) {
          setHintsOpen(true);
        }
      } catch (e) {
        console.error(e);
      }
    };

    fetchUser();

    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const handleHintsClose = async () => {
    if (dontShowAgain) {
      try {
        await fetch("/api/user/disable-hints", {
          method: "POST",
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        });
      } catch (e) {
        console.error(e);
      }
    }

    setHintsOpen(false);
  };
  return (
    <div
      style={{
        backgroundImage: `url(${Background})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        height: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
      }}
    >
      <div
        style={{
          backgroundColor: "rgba(255, 255, 255, 0.95)",
          padding: "50px 40px",
          borderRadius: "16px",
          textAlign: "center",
          boxShadow: "0 12px 24px rgba(0,0,0,0.25)",
          maxWidth: "500px",
          width: "100%",
        }}
      >
        <h1 style={{ marginBottom: "24px", color: "#1F2937", fontSize: "32px" }}>
          Skydive Book
        </h1>

        <p style={{ marginBottom: "32px", fontSize: "17px", color: "#4B5563" }}>
          Веди учёт своих прыжков, анализируй данные и достигай новых высот.
        </p>
        <div style={{
          display: "flex",
          justifyContent: "center",
          marginBottom: "20px"
        }}>
          <div style={{
            display: "flex",
            background: "#E5E7EB",
            borderRadius: "999px",
            padding: "4px",
            width: "100%",
            maxWidth: "320px"
          }}>

            {/* ПАРАШЮТ */}
            <button
              onClick={() => setMode("skydive")}
              style={{
                flex: 1,
                padding: "8px",
                borderRadius: "999px",
                border: "none",
                cursor: "pointer",
                fontWeight: "600",
                background: mode === "skydive" ? "#1D4ED8" : "transparent",
                color: mode === "skydive" ? "#fff" : "#374151",
                transition: "0.2s"
              }}
            >
              🪂 Скайдайв
            </button>

            {/* ТРУБА */}
            <button
              onClick={() => setMode("tunnel")}
              style={{
                flex: 1,
                padding: "8px",
                borderRadius: "999px",
                border: "none",
                cursor: "pointer",
                fontWeight: "600",
                background: mode === "tunnel" ? "#7C3AED" : "transparent",
                color: mode === "tunnel" ? "#fff" : "#374151",
                transition: "0.2s"
              }}
            >
              🌀 Аэротруба
            </button>

          </div>
        </div>
        <div style={{ display: "flex", flexDirection: "column", gap: "14px" }}>

          {/* 1 кнопка */}
          <Link
            to={mode === "skydive" ? "/jumps" : "/tunnel"}
            style={{ ...buttonBaseStyle, backgroundColor: theme.primary }}
            onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = theme.primaryHover)}
            onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = theme.primary)}
          >
            {mode === "skydive" ? "Список прыжков" : "Список сессий"}
          </Link>

          {/* 2 кнопка */}
          <Link
            to={mode === "skydive" ? "/add-jump" : "/add-session"}
            style={{ ...buttonBaseStyle, backgroundColor: theme.secondary }}
            onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = theme.secondaryHover)}
            onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = theme.secondary)}
          >
            {mode === "skydive" ? "Добавить прыжок" : "Добавить сессию"}
          </Link>

          {/* 3 кнопка */}
          <Link
            to="/personal"
            style={{ ...buttonBaseStyle, backgroundColor: theme.neutral }}
            onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = theme.neutralHover)}
            onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = theme.neutral)}
          >
            Личный кабинет
          </Link>

        </div>

        {/* КНОПКА О ПРОЕКТЕ */}
        <button
          onClick={() => setAboutOpen(true)}
          style={{
            marginTop: "20px",
            background: "transparent",
            border: "none",
            color: "#6B7280",
            fontSize: "14px",
            cursor: "pointer",
            textDecoration: "underline",
          }}
        >
          О проекте
        </button>
      </div>


      {hintsOpen && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            backgroundColor: "rgba(0,0,0,0.75)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 3000,
            padding: "15px",
          }}
        >
          <div
            style={{
              backgroundColor: "#111827",
              padding: "25px",
              borderRadius: "16px",
              width: "100%",
              maxWidth: "700px",
              maxHeight: "85vh",
              overflowY: "auto",
              color: "#F3F4F6",
              boxShadow: "0 20px 50px rgba(0,0,0,0.8)",
              textAlign: "center",
            }}
          >
            <h2 style={{ marginBottom: "15px" }}>Добро пожаловать 👋</h2>

            <p style={{ fontSize: "15px", color: "#D1D5DB", marginBottom: "15px" }}>
              Рекомендуем потратить пару минут и ознакомиться с основными возможностями сайта - это поможет быстрее разобраться и использовать его максимально эффективно.
            </p>

            <div style={{
              textAlign: "left",
              lineHeight: "1.7",
              color: "#E5E7EB",
              fontSize: "14px"
            }}>
              <p>
                <b>📋 Список прыжков</b><br />
                Здесь вы найдете все свои прыжки и краткую информацию по каждому из них.
                Вы можете открыть любой прыжок и посмотреть подробную статистику.
              </p>

              <p>
                <b>📊 Страница прыжка</b><br />
                Отображает детальную информацию о прыжке. Через меню действий можно поделиться публичной ссылкой с друзьями.
                Если были загружены данные с высотомера - вы увидите подробный график высоты и скорости.
              </p>

              <p>
                <b>➕ Добавление прыжка</b><br />
                Вы можете добавить один или сразу несколько прыжков.
                Доступна загрузка данных с логбука (если устройство поддерживается).
                Если вашего устройства нет в списке поддерживаемых - напишите нам, и мы постараемся его добавить.
              </p>

              <p><i>
                <b style={{ color: "#b64f4f" }}>💡 Полезная подсказка</b><br />
                Если у вас уже есть история прыжков - не нужно заносить всё вручную.
                Можно сразу указать общее количество прыжков через счетчик.<br />

                Если хотите учесть время свободного падения - добавьте все прыжки одной записью,
                а один отдельный прыжок создайте вручную, указав общее время.
              </i></p>

              <p>
                <b>👤 Личный кабинет</b><br />
                Здесь собрана вся информация о вашей скайдайв-карьере: статистика, дропзоны, снаряжение и другое.
                Удобно отслеживать общее время свободного падения и сезонные итоги.
              </p>

              <p>
                Через меню действий вы можете:
                <ul style={{ marginTop: "5px", marginBottom: "10px" }}>
                  <li>поделиться своим профилем</li>
                  <li>установить аватар</li>
                  <li>изменить пароль</li>
                  <li>обновить текущую систему</li>
                </ul>
              </p>

              <p>
                <i style={{ color: "#756d6d" }}>Больше информации о проекте можно найти на странице <b>"О проекте"</b></i>.<br /><br />
                <b>Надеемся, вам будет удобно и приятно пользоваться SkydiveBook ✈️</b>
              </p>
            </div>

            {/* Чекбокс */}
            <label style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "8px",
              marginBottom: "20px",
              fontSize: "14px",
              color: "#9CA3AF",
              cursor: "pointer"
            }}>
              <input
                type="checkbox"
                checked={dontShowAgain}
                onChange={(e) => setDontShowAgain(e.target.checked)}
              />
              Больше не показывать
            </label>

            <button
              onClick={handleHintsClose}
              style={{
                width: "100%",
                padding: "12px",
                borderRadius: "10px",
                border: "none",
                background: "linear-gradient(135deg, #FFD700, #FFA500)",
                color: "#000",
                fontWeight: "600",
                cursor: "pointer",
              }}
            >
              Понятно
            </button>
          </div>
        </div>
      )}

      {/* МОДАЛКА */}
      {aboutOpen && (
        <div
          onClick={() => setAboutOpen(false)}
          style={{
            position: "fixed",
            inset: 0,
            backgroundColor: "rgba(0,0,0,0.75)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 2000
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              backgroundColor: "#111827",
              padding: "30px",
              borderRadius: "16px",
              width: "90%",
              maxWidth: "800px",
              maxHeight: "85vh",
              overflowY: "auto",
              color: "#F3F4F6",
              boxShadow: "0 20px 50px rgba(0,0,0,0.8)",
              lineHeight: "1.6"
            }}
          >
            <h2 style={{ marginBottom: "20px", textAlign: "center" }}>О проекте</h2>

            {/* БЛОК С АВТОРОМ */}
            <div style={{ marginBottom: "25px" }}>
              <div style={{ lineHeight: "1.6" }}>

                {/* АВАТАР */}
                <img
                  src={author}
                  alt="Автор"
                  style={{
                    width: isMobile ? "100%" : "300px",
                    height: isMobile ? "auto" : "300px",
                    borderRadius: "12px",
                    objectFit: "cover",
                    float: isMobile ? "none" : "left",
                    marginRight: isMobile ? "0" : "20px",
                    marginBottom: "15px"
                  }}
                />

                <p style={{ textAlign: "left" }}>
                  <br />
                  <b>Рад приветствовать Вас на страницах данного проекта!</b>
                  <br /><br />
                  Меня зовут Федор, я создатель и единственный разработчик сайта <b>SkydiveBook</b>, вдохновленный, как и Вы, безграничной свободой, которое дарит нам небо.
                  <br />
                  <br />
                  SkydiveBook создан как инструмент для удобного хранения, ведения и просмотра журнала прыжков с парашютом и свободного падения.
                  <br /><br /><br /><br />
                  На страницах данного сайта Вы сможете найти все, что поможет Вам сохранить лучшие моменты своего скайдайв опыта:
                </p>

                <ul>
                  <li>анализировать выполненные прыжки</li>
                  <li>смотреть личную статистику прыжков/свободного падения/дропзон и много чего еще</li>
                  <li>добавлять данные о прыжках вручную или выгружать подробные данные с высотомеров</li>
                  <li>вести учет времени свободного падения для удобного подведения годовых итогов</li>
                  <li>добавлять в друзья Ваших знакомых и в любой момент просматривать их общую статистику</li>
                  <li>делиться своим профилем с друзьями и в соц. сетях</li>
                  <li>добавлять к записи прыжка свои впечатления, ссылки на видео и фото</li>
                  <li>и много чего еще, так как сайт активно развивается</li>
                </ul>

                <p>
                  Есть две причины, по которым я бы хотел <u>предостеречь Вас</u> о внесении ложной информации о прыжках:
                  <br />1. На сайте отсутствует рейтинговая система, так как мы все в первую очередь выступаем за безопасность прыжков и не приветствуем погоню за рекордами с риском для здоровья и жизни
                  <br />2. Сайт не предполагает верификацию данных ввиду технических ограничений.
                  <br /><br />
                  Таким образом, призываю Вас соблюдать принципы доверия и честности по отношению друг к другу.
                  <br /><br />
                  Весь функционал сайта доступен Вам с момента регистрации без каких-либо ограничений, подписок и платного функционала.
                  Сайт находится в стадии постоянного развития, но я гарантирую Вам, что ни рекламы, ни платных функций здесь не появится.
                </p>

                {/* ОЧИСТКА FLOAT */}
                <div style={{ clear: "both" }} />

              </div>
            </div>


            {/* БЛОК С ДОНАТОМ */}
            <div style={{ lineHeight: "1.6" }}>

              {/* QR */}
              <img
                src={qrCode}
                alt="QR донат"
                style={{
                  width: isMobile ? "100%" : "160px",
                  height: isMobile ? "auto" : "160px",
                  borderRadius: "12px",
                  background: "#fff",
                  padding: "5px",
                  float: isMobile ? "none" : "right",
                  marginLeft: isMobile ? "0" : "20px",
                  marginBottom: "15px"
                }}
              />

              <p>
                Однако, сайт требует регулярных финансовых затрат на развитие и содержание.
                Если вдруг Вы хотите абсолютно добровольно и безвозмездно поддержать проект и автора — тут вы видите QR-код для доната.
                <br /><br />
                Вся ваша помощь пойдет исключительно на развитие сайта и оплату серверов, на которых он функционирует.
                <br /><br />
                Также всегда приветствуются идеи, обратная связь и сообщения об ошибках!
              </p>

              <p>
                По всем вопросам:
                <br />
                <a href="https://vk.com/club237344374" target="_blank">Официальное сообщество ВК</a>
                <br /><br />
                Спасибо, что вы часть SkydiveBook ❤️
              </p>

              {/* ОЧИСТКА FLOAT */}
              <div style={{ clear: "both" }} />

            </div>

            <button
              onClick={() => setAboutOpen(false)}
              style={{
                marginTop: "30px",
                width: "100%",
                padding: "12px",
                borderRadius: "10px",
                border: "none",
                backgroundColor: "#10B981",
                color: "#022C22",
                fontWeight: "600",
                cursor: "pointer"
              }}
            >
              Закрыть
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default LandingPage;